import React, { useEffect, useState } from 'react'
import styles from './groupAdd.jcss'
import EditText from '../../../blocks.simple/editText/editText'
import translate from '../../../core/translate'
import Button from '../../../blocks.simple/button/button'
import Checkbox from '../../../blocks.simple/checkbox/checkbox'
import { Switch } from '../../../atoms/Switch'
import { cn } from 'ethcss'
import Icon from '../../../blocks.simple/icon/icon'
import { api } from '../../../core/api/ConnectionManager'
import { IChannel } from '../__channels/Channels'

export const GroupAdd = ({ group, onChange, onClose, onSave }: any) => {
    const [channelsSelect, setChannelsSelect] = useState<boolean>(false)
    const [channelsInGroupList, setChannelsInGroupList] = useState<IChannel[]>(group.channels)
    const [channelsList, setChannelsList] = useState<IChannel[]>([])
    const [selectedChannels, setSelectedChannels] = useState<IChannel[]>([])
    const [selectedChannelsInGroup, setSelectedChannelsInGroup] = useState<IChannel[]>([])

    const getChannelsList = () => {
        api.send<object, { data: IChannel[] }>('getChannelList', {
            limit: 1000,
            sort: [['order', 'ASC']],
        }).then((res) => {
            if (!res || !res.data) return

            setChannelsList(res.data)
        })
    }

    const onApplyChannelsList = () => {
        onChange('channels', channelsInGroupList)

        setChannelsSelect(false)
    }

    useEffect(() => {
        getChannelsList()
    }, [])

    return group ? (
        <div className={styles.categoryAdd}>
            {channelsSelect && (
                <div className={styles.inner}>
                    <div className={styles.channelSelectionBlock}>
                        <div className={styles.selectionCol}>
                            <table className={styles.table}>
                                <tr className={cn(styles.trSelection, styles.trHeader)}>
                                    <td>
                                        <Checkbox
                                            checked={
                                                channelsList.filter((channel) =>
                                                    channelsInGroupList.every((item) => item.id !== channel.id)
                                                ).length !== 0 &&
                                                selectedChannels.length ===
                                                    channelsList.filter((channel) =>
                                                        channelsInGroupList.every((item) => item.id !== channel.id)
                                                    ).length
                                            }
                                            onClick={(checked: any) => {
                                                if (checked) {
                                                    setSelectedChannels(
                                                        channelsList.filter((channel) =>
                                                            channelsInGroupList.every((item) => item.id !== channel.id)
                                                        )
                                                    )

                                                    return
                                                }

                                                setSelectedChannels([])
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {translate('channelsOf')}{' '}
                                        {
                                            channelsList.filter((channel) =>
                                                channelsInGroupList.every((item) => item.id !== channel.id)
                                            ).length
                                        }
                                    </td>
                                </tr>
                                {channelsList
                                    .filter((channel) => channelsInGroupList.every((item) => item.id !== channel.id))
                                    .map((channel: any) => {
                                        return (
                                            <tr className={styles.trSelection}>
                                                <td>
                                                    <Checkbox
                                                        checked={selectedChannels.some(
                                                            (item) => item.id === channel.id
                                                        )}
                                                        onClick={() => {
                                                            if (
                                                                selectedChannels.some((item) => item.id === channel.id)
                                                            ) {
                                                                setSelectedChannels(
                                                                    selectedChannels.filter(
                                                                        (item) => item.id !== channel.id
                                                                    )
                                                                )

                                                                return
                                                            }

                                                            setSelectedChannels([...selectedChannels, channel])
                                                        }}
                                                    />
                                                </td>
                                                <td>{channel.title}</td>
                                            </tr>
                                        )
                                    })}
                            </table>
                        </div>
                        <div>
                            <Icon
                                type={'selectRight'}
                                onClick={() => {
                                    const list: IChannel[] = []

                                    selectedChannels.forEach((channel) => {
                                        const element: IChannel = { ...channel }

                                        if (element.visible === undefined) {
                                            element.visible = true
                                        }

                                        list.push(element)
                                    })

                                    setChannelsInGroupList([...channelsInGroupList, ...list])

                                    setSelectedChannels([])
                                }}
                                size={32}
                                tooltip={{ title: translate('addToGroup') }}
                            />
                            <Icon
                                type={'selectLeft'}
                                size={32}
                                onClick={() => {
                                    setChannelsInGroupList(
                                        channelsInGroupList.filter(
                                            (channel) => !selectedChannelsInGroup.some((item) => item.id === channel.id)
                                        )
                                    )

                                    setSelectedChannelsInGroup([])
                                }}
                                tooltip={{ title: translate('removeFromGroup') }}
                            />
                        </div>
                        <div className={styles.selectionCol}>
                            <table className={styles.table}>
                                <tr className={cn(styles.trSelection, styles.trHeader)}>
                                    <td>
                                        <Checkbox
                                            checked={
                                                selectedChannelsInGroup.length !== 0 &&
                                                selectedChannelsInGroup.length === channelsInGroupList.length
                                            }
                                            onClick={(checked: any) => {
                                                if (checked) {
                                                    setSelectedChannelsInGroup(channelsInGroupList)

                                                    return
                                                }

                                                setSelectedChannelsInGroup([])
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {translate('channelsGroupOf')} {channelsInGroupList.length}
                                    </td>
                                </tr>
                                {channelsInGroupList.map((channel: any) => {
                                    return (
                                        <tr className={styles.trSelection} key={channel.id}>
                                            <td>
                                                <Checkbox
                                                    checked={selectedChannelsInGroup.some(
                                                        (item) => item.id === channel.id
                                                    )}
                                                    onClick={() => {
                                                        if (
                                                            selectedChannelsInGroup.some(
                                                                (item) => item.id === channel.id
                                                            )
                                                        ) {
                                                            setSelectedChannelsInGroup(
                                                                selectedChannelsInGroup.filter(
                                                                    (item) => item.id !== channel.id
                                                                )
                                                            )

                                                            return
                                                        }

                                                        setSelectedChannelsInGroup([
                                                            ...selectedChannelsInGroup,
                                                            channel,
                                                        ])
                                                    }}
                                                />
                                            </td>
                                            <td>{channel.title}</td>
                                        </tr>
                                    )
                                })}
                            </table>
                        </div>
                    </div>
                    <div className={styles.controlsWide}>
                        <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                            {translate('back')}
                        </Button>
                        <Button mod="fill" className={styles.button} onClick={onApplyChannelsList}>
                            {translate('apply')}
                        </Button>
                    </div>
                </div>
            )}
            {!channelsSelect && (
                <div className={styles.inner}>
                    <div className={styles.addGroupDesc}>{translate('addGroupDesc')}</div>
                    <div className={styles.field}>
                        <EditText
                            value={group.title}
                            onChange={(value: string) => {
                                onChange('title', value)
                            }}
                            containerClass={styles.separator}
                            className={styles.input}
                            label={translate('name')}
                        />
                    </div>
                    <Button
                        mod={'withBorder'}
                        className={cn(styles.button, styles.channelSelectBtn)}
                        onClick={() => setChannelsSelect(true)}
                    >
                        {translate('selectChannels')}
                    </Button>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <tr className={cn(styles.tr, styles.trHeader)}>
                                <td>
                                    {translate('channelsOf')} {group.channels.length}
                                </td>
                                <td></td>
                            </tr>
                            {group.channels.map((channel: any) => {
                                return (
                                    <tr
                                        className={cn(styles.tr, !channel.globalVisible ? styles.disabled : '')}
                                        key={channel.id}
                                    >
                                        <td>{channel.title}</td>
                                        <td style={{ pointerEvents: !channel.globalVisible ? 'none' : 'auto' }}>
                                            <Switch
                                                onChange={() => {
                                                    onChange(
                                                        'channels',
                                                        group.channels.map((item: any) => {
                                                            if (item.id === channel.id) {
                                                                return {
                                                                    ...item,
                                                                    visible: !item.visible,
                                                                }
                                                            }

                                                            return item
                                                        })
                                                    )
                                                }}
                                                checked={channel.visible}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </table>
                    </div>
                    <div className={styles.controlsWide}>
                        <Button mod={'withBorder'} className={styles.button} onClick={onClose}>
                            {translate('cancel')}
                        </Button>
                        <Button mod="fill" className={styles.button} onClick={onSave} disabled={!group.title}>
                            {translate(group.id ? 'save' : 'create')}
                        </Button>
                    </div>
                </div>
            )}
        </div>
    ) : null
}
